// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasParentProductId, withParentProductId } from "@insite/client-framework/Components/ParentProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getProductState } from "@insite/client-framework/Store/Data/Products/ProductsSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

/* Starter Custom Code - Start */
import ListItem, { UnorderedList } from "@insite/mobius/Lists";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { spacingStyles } from "@toolkit/Themes/common/mixins/spacing";
/* Starter Custom Code - End */

type Props = WidgetProps & ReturnType<typeof mapStateToProps> & HasParentProductId;

const mapStateToProps = (state: ApplicationState, ownProps: HasParentProductId) => ({
    configuration: getProductState(state, ownProps.parentProductId).value?.detail?.configuration,
});

export interface ProductDetailsKitSectionOptionsStyles {
    wrapper?: InjectableCss;
    configSectionWrapper?: InjectableCss;
    configSectionLabel?: TypographyPresentationProps;
    sectionOptionText?: TypographyPresentationProps;
    // Starter Custom Code
    list?: InjectableCss;
}

export const productDetailsKitSectionOptionsStyles: ProductDetailsKitSectionOptionsStyles = {
    wrapper: {
        css: css`
            ${x =>
                spacingStyles(
                    x.theme.design.product.detail.contentSpacing,
                    x.theme.design.product.detail.contentSpacing,
                )};
        `,
    },
    configSectionWrapper: {
        css: css`
            ${spacingStyles(pxToRem(10), pxToRem(10))};
        `,
    },
    configSectionLabel: {
        css: css`
            ${x => x.theme.formField.defaultProps?.labelProps?.css};
        `,
    },
    list: {
        css: css`
            list-style-type: none;
            padding-left: 0;
        `,
    },
};

const styles = productDetailsKitSectionOptionsStyles;

const ProductDetailsKitSectionOptions = ({ configuration }: Props) => {
    if (
        !configuration ||
        !configuration.isKit ||
        !configuration.configSections ||
        configuration.configSections.length === 0
    ) {
        return null;
    }

    return (
        <StyledWrapper {...styles.wrapper}>
            {configuration.configSections.map(
                configSection =>
                    !!configSection.sectionOptions?.length && (
                        <StyledWrapper {...styles.configSectionWrapper} key={configSection.id}>
                            <Typography {...styles.configSectionLabel}>
                                {configSection.label || configSection.sectionName}:
                            </Typography>
                            <UnorderedList {...styles.list} /* Starter Custom Code */>
                                {configSection.sectionOptions?.map(sectionOption => (
                                    <ListItem key={sectionOption.id} /* Starter Custom Code */>
                                        {sectionOption.description}
                                    </ListItem>
                                ))}
                            </UnorderedList>
                        </StyledWrapper>
                    ),
            )}
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: withParentProductId(connect(mapStateToProps)(ProductDetailsKitSectionOptions)),
    definition: {
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
